export const HTML_BLOCK_MESSAGE_SOURCE = 'max-html-block'
export const HTML_BLOCK_MIN_HEIGHT = 80
export const HTML_BLOCK_MAX_HEIGHT = 1400
export const HTML_BLOCK_SANDBOX = 'allow-scripts allow-modals'
export const HTML_BLOCK_REFERRER_POLICY = 'no-referrer'
export const HTML_BLOCK_LOAD_TIMEOUT = 3000
export const HTML_BLOCK_RELEASE_DELAY = 2000
export const HTML_BLOCK_LOAD_ROOT_MARGIN = '100%'
export const HTML_BLOCK_RELEASE_ROOT_MARGIN = '300%'

export const HTML_BLOCK_CSP_DIRECTIVES = [
  "default-src 'none'",
  "img-src 'self' data: https:",
  "style-src 'unsafe-inline'",
  'font-src data:',
  "connect-src 'none'",
  "form-action 'none'",
  "base-uri 'none'",
  "frame-src 'none'",
  "object-src 'none'",
] as const

export type HtmlBlockPolicy = {
  readonly limits: {
    readonly blocksPerMessage: number
    readonly concurrentFrames: number
    readonly snippetBytes: number
  }
  readonly messageSource: string
  readonly frame: {
    readonly minHeightPx: number
    readonly maxHeightPx: number
  }
  readonly timing: {
    readonly loadTimeoutMs: number
    readonly releaseDelayMs: number
  }
  readonly visibility: {
    readonly loadRootMargin: string
    readonly releaseRootMargin: string
  }
}

export const HTML_BLOCK_POLICY: HtmlBlockPolicy = Object.freeze({
  limits: Object.freeze({
    blocksPerMessage: 3,
    concurrentFrames: 4,
    snippetBytes: 128 * 1024,
  }),
  messageSource: HTML_BLOCK_MESSAGE_SOURCE,
  frame: Object.freeze({
    minHeightPx: HTML_BLOCK_MIN_HEIGHT,
    maxHeightPx: HTML_BLOCK_MAX_HEIGHT,
  }),
  timing: Object.freeze({
    loadTimeoutMs: HTML_BLOCK_LOAD_TIMEOUT,
    releaseDelayMs: HTML_BLOCK_RELEASE_DELAY,
  }),
  visibility: Object.freeze({
    loadRootMargin: HTML_BLOCK_LOAD_ROOT_MARGIN,
    releaseRootMargin: HTML_BLOCK_RELEASE_ROOT_MARGIN,
  }),
})
